<template>
  <div class="p-2 sm:p-3 select-none">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-3xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12">
          <h1 class="font-semibold text-2xl lg:text-3xl text-center">
            Payment confirmation
          </h1>
          <div>
            <div class="mt-12">
              <div>Do you have promo-code?</div>
              <PromoCode class="mt-4"/>
            </div>
            <div class="mt-12">
              <vue-skeleton-loader
                  v-if="payment_methods_loading"
                  :height="60"
                  :width="672"
                  animation="wave"
                  class="w-full"
                  type="rect"
              />
              <div v-else>
                <div v-if="paymentMethods.length > 0">
                  <p class="mb-5">Please select an existing payment method or add new payment method</p>
                  <select v-model="selected_payment_method" class="input uppercase">
                    <option disabled value="">Please select an existing payment method</option>
                    <optgroup label="Add new payment method">
                      <option value="add_card">Add new payment method</option>
                    </optgroup>
                    <optgroup label="Select existing payment method">

                      <option v-for="(method, key) in paymentMethods" :key="method.id" :value="method.id">{{ key + 1 }}.
                        {{ method.card.brand }}
                        -
                        {{
                          method.card.last4
                        }}
                      </option>
                    </optgroup>

                  </select>
                </div>
              </div>

            </div>
            <!--            <div class="mt-12">-->
            <!--              This card will be used for payments, when all attendee complete own-->
            <!--              orders.-->
            <!--            </div>-->
            <div class="mx-auto my-10">
              <setup-intent v-if="canSetupIntent"/>
            </div>
          </div>

          <!-- bottom navigation -->
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    v-if="submit_method_loading"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                >
                  <spinner class="mx-auto"/>
                </button>
                <button
                    v-else
                    :disabled="!canSubmit"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    @click="submit"
                >
                  <span>Next</span>
                </button>

              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Info boxes sidebar -->
      <div>
        <info-box class="m-2">
          You will not be charged until all attendees have placed orders and it is complete.
        </info-box>
      </div>
      <!-- ### -->

    </div>
  </div>
</template>

<script>
import PromoCode from '@/components/common/payments/PromoCodeComponent'
import ApiV1 from '@/api/api_v1.0'
import Api from '@/api/api_v1.0'
import SetupIntent from '@/components/payment/SetupIntent.vue'
import Spinner from '@/components/common/Spinner.vue'
import InfoBox from '@/components/common/InfoBox.vue'

export default {
  name      : 'payment-confirmation',
  components: { InfoBox, Spinner, SetupIntent, PromoCode },
  data () {
    return {
      payment_methods_loading: false,
      selected_payment_method: '',
      adding_payment_method  : false,
      submit_method_loading  : false,
      paymentMethods         : []
    }
  },

  computed: {
    canSetupIntent () {
      return this.selected_payment_method === 'add_card'
    },
    order () {
      return this.$store.state.currentEditingOrder
    },
    canSubmit () {
      return this.selected_payment_method !== 'add_card' && this.selected_payment_method !== ''
    },
  },
  async mounted () {
    await this.getPaymentMethods()

    if (this.paymentMethods.length > 0) {
      if (this.order.session_id) {
        this.selected_payment_method = this.order.session_id
      }
    } else {
      this.selected_payment_method = 'add_card'
    }

  },
  methods: {
    async getPaymentMethods () {
      this.payment_methods_loading = true
      let response = await ApiV1.getPaymentMethods(this.order.uuid)
      this.paymentMethods = response.data.data
      this.payment_methods_loading = false
    },

    async submit () {
      this.submit_method_loading = true
      const formData = new FormData
      formData.append('_method', 'PUT')
      formData.append('session_id', this.selected_payment_method)
      await Api.updateOrderDetailsFormdata(
          this.order.uuid,
          formData,
      ).then(() => {
        this.$emit('submit')
      }).catch(e => {
        alert('ERROR! ' + e.message)
        return false
      })
      this.submit_method_loading = false
    },
    back () {
      this.$emit('back')
    },
  },
}
</script>

<style scoped></style>
